export default "__VITE_ASSET__CNerdLY2__"